import { constants, actions } from 'ducks-helpers';

//  SUFFIXES
// [
//   'LOADING',
//   'PENDING',
//   'SUCCESS',
//   'ERROR',
//   'FAILED',
//   'CANCELED'
// ]

export const TYPE = constants('masters', [
    '~FETCH_MASTERS',
    '~PREPARE_FILTER'
]);

export const ACTION = actions(TYPE);
